
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  NodeTypes,
  OnNodesChange,
  OnEdgesChange,
  OnConnect,
} from '@xyflow/react';
import CustomNode from './CustomNode';
import { WorkflowNode, WorkflowEdge } from './types';

type WorkflowCanvasProps = {
  nodes: WorkflowNode[];
  edges: WorkflowEdge[];
  onNodesChange: OnNodesChange;
  onEdgesChange: OnEdgesChange;
  onConnect: OnConnect;
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  onDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
};

const WorkflowCanvas = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  onDrop,
  onDragOver
}: WorkflowCanvasProps) => {
  // Define node types for ReactFlow
  const nodeTypes: NodeTypes = {
    custom: CustomNode as any // Use type assertion to avoid complex type issues
  };

  return (
    <div 
      className="h-full rounded-xl border border-border shadow-sm overflow-hidden"
      onDrop={onDrop}
      onDragOver={onDragOver}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        fitView
        className="bg-white"
        minZoom={0.5}
        maxZoom={1.5}
        defaultViewport={{ x: 0, y: 0, zoom: 0.85 }}
      >
        <Background color="#f0f0f0" gap={16} size={1} />
        <Controls position="bottom-right" />
        <MiniMap 
          nodeStrokeColor={(n) => n.selected ? '#ff0072' : '#555'}
          nodeColor={(n) => n.selected ? '#f7f7f7' : '#fff'}
          style={{ backgroundColor: '#f7f9fb' }}
        />
      </ReactFlow>
    </div>
  );
};

export default WorkflowCanvas;
